import React, { FC, memo } from 'react'

import { focusIds } from '@/constants/focus'
import { IconButtonProps } from '@/types/componentsPropsTypes'

import { IconButtonElem } from './styles'

const IconButtonRaw: FC<IconButtonProps> = ({
  iconSrc,
  onClick,
  disabled,
  onDown,
  focusId = `${focusIds.ICON_BUTTON}${iconSrc}`,
}) => {
  return (
    <IconButtonElem
      elementType="button"
      focusId={focusId}
      onSelected={onClick}
      disabled={disabled}
      onDown={onDown}
    >
      <img src={iconSrc} alt="" />
    </IconButtonElem>
  )
}

export const IconButton = memo(IconButtonRaw)
